import { render, staticRenderFns } from "./GrowthbookFeatureDetailsModal.vue?vue&type=template&id=c2f33ad2&scoped=true"
import script from "./GrowthbookFeatureDetailsModal.vue?vue&type=script&lang=js"
export * from "./GrowthbookFeatureDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./GrowthbookFeatureDetailsModal.vue?vue&type=style&index=0&id=c2f33ad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f33ad2",
  null
  
)

export default component.exports